import "./bootstrap";
import "../css/app.css";

///////////// Tailwind section //////////////
import {
    Collapse,
    Select,
    Carousel,
    initTE,
    Modal,
    Ripple,
    Dropdown,
    Datepicker,
    Input,
    Tab,
} from "tw-elements";
initTE({
    Collapse,
    Select,
    Carousel,
    Modal,
    Ripple,
    Dropdown,
    Datepicker,
    Input,
    Tab,
});

//////////////................/////////////////

import { createApp } from "vue/dist/vue.esm-bundler";
import { store } from "./Store";
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import Notifications from "@kyvg/vue3-notification";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
    authDomain: import.meta.env.VITE_GOOGLE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_GOOGLE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_GOOGLE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_GOOGLE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_GOOGLE_APP_ID,
    measurementId: import.meta.env.VITE_GOOGLE_MEASUREMENT_ID,
};

const app = createApp({});
firebase.initializeApp(firebaseConfig);

import NavBarComponent from "./Components/Common/NavBarComponent.vue";
import StaffListComponent from "./Components/Staff/StaffListComponent.vue";
import StaffCreateComponent from "./Components/Staff/StaffCreateComponent.vue";
import StaffEditComponent from "./Components/Staff/StaffEditComponent.vue";
import TasksCrudComponent from "./Components/Tasks/TasksCrudComponent.vue";
import TaskReportComponent from "./Components/Tasks/TaskReportComponent.vue";
import DepartmentsCrudComponent from "./Components/Departments/DepartmentsCrudComponent.vue";
import RolesCrudComponent from "./Components/Roles/RolesCrudComponent.vue";
import AreasCrudComponent from "./Components/Areas/AreasCrudComponent.vue";
import InventoriesCrudComponent from "./Components/Inventories/InventoriesCrudComponent.vue";
import RoomCrudComponent from "./Components/TablesAndRooms/RoomCrudComponent.vue";
import ServicesCrudComponent from "./Components/Services/ServicesCrudComponent.vue";
import InventoryLedgersComponent from "./Components/Inventories/InventoryLedgersComponent.vue";
import InventoryOpeningComponent from "./Components/Inventories/InventoryOpeningComponent.vue";
import InventoryReceivesListComponent from "./Components/Transfers/InventoryReceivesListComponent.vue";
import InventoryTransfersListComponent from "./Components/Transfers/InventoryTransfersListComponent.vue";
import InventoryTransferHistoryListComponent from "./Components/Transfers/InventoryTransferHistoryListComponent.vue";
import UsedDefectedItemsListComponent from "./Components/UsedDefectedItems/UsedDefectedItemsListComponent.vue";
import MenuCategoryCrudComponent from "./Components/Menus/MenuCategoryCrudComponent.vue";
import MenuListComponent from "./Components/Menus/MenuListComponent.vue";
import MenuCreateComponent from "./Components/Menus/MenuCreateComponent.vue";
import MenuEditComponent from "./Components/Menus/MenuEditComponent.vue";
import ComplainsCrudComponent from "./Components/Complains/ComplainsCrudComponent.vue";
import PurchaseOrderListComponent from "./Components/PurchaseOrders/PurchaseOrderListComponent.vue";
import PurchaseOrderCreateComponent from "./Components/PurchaseOrders/PurchaseOrderCreateComponent.vue";
import PurchaseOrderEditComponent from "./Components/PurchaseOrders/PurchaseOrderEditComponent.vue";
import PurchaseOrderConfirmComponent from "./Components/PurchaseOrders/PurchaseOrderConfirmComponent.vue";
import PurchaseOrderBuyComponent from "./Components/PurchaseOrders/PurchaseOrderBuyComponent.vue";
import ConfirmPurchaseOrderItemsComponent from "./Components/PurchaseOrders/ConfirmPurchaseOrderItemsComponent.vue";
import PurchaseOrderWithLeftItemsComponent from "./Components/PurchaseOrders/PurchaseOrderWithLeftItemsComponent.vue";
import LeftItemListComponent from "./Components/PurchaseOrders/LeftItemListComponent.vue";
import BrandCrudComponent from "./Components/Brands/BrandCrudComponent.vue";
import ItemListComponent from "./Components/Items/ItemListComponent.vue";
import ItemCreateComponent from "./Components/Items/ItemCreateComponent.vue";
import ItemEditComponent from "./Components/Items/ItemEditComponent.vue";
import SellingExtraListComponent from "./Components/SellingExtras/SellingExtraListComponent.vue";
import ItemSuppliersComponent from "./Components/Items/ItemSuppliersComponent.vue";
import SupplierBrandsComponent from "./Components/Items/SupplierBrandsComponent.vue";
import ItemPricingHistoryComponent from "./Components/Items/ItemPricingHistoryComponent.vue";
import ItemUsageForecastListComponent from "./Components/ItemUsageForecastings/ItemUsageForecastListComponent.vue";
import ItemUsageForecastCreateComponent from "./Components/ItemUsageForecastings/ItemUsageForecastCreateComponent.vue";
import ItemUsageForecastDetailComponent from "./Components/ItemUsageForecastings/ItemUsageForecastDetailComponent.vue";
import UomConversionCrudComponent from "./Components/ItemUom/UomConversionCrudComponent.vue";
import AccountingCrudComponent from "./Components/Accounting/AccountingCrudComponent.vue";
import FinancialTransactionCrudComponent from "./Components/FinancialTransaction/FinancialTransactionCrudComponent.vue";
import CashbookCrudComponent from "./Components/Cashbook/CashbookCrudComponent.vue";
import ApListComponent from "./Components/AP/ApListComponent.vue";
import ApHistoryComponent from "./Components/AP/ApHistoryComponent.vue";
import ArCrudComponent from "./Components/AR/ArCrudComponent.vue";
import ArDetailComponent from "./Components/AR/ArDetailComponent.vue";
import ArHistoryComponent from "./Components/AR/ArHistoryComponent.vue";
import ArPaidComponent from "./Components/AR/ArPaidComponent.vue";
import SupplierListComponent from "./Components/Supplier/SupplierListComponent.vue";
import SupplierCreateComponent from "./Components/Supplier/SupplierCreateComponent.vue";
import SupplierUpdateComponent from "./Components/Supplier/SupplierUpdateComponent.vue";
import SupplierDetailComponent from "./Components/Supplier/SupplierDetailComponent.vue";
import SupplierLeadTimeComponent from "./Components/Supplier/SupplierLeadTimeComponent.vue";
import FixedAssetCrudComponent from "./Components/FixedAssets/FixedAssetCrudComponent.vue";
import AssetItemCrudComponent from "./Components/FixedAssets/AssetItemCrudComponent.vue";
import AssetCrudComponent from "./Components/FixedAssets/AssetCrudComponent.vue";
import TableCrudComponent from "./Components/TablesAndRooms/TableCrudComponent.vue";
import PackagesListComponent from "./Components/Packages/PackagesListComponent.vue";
import PackagesCreateComponent from "./Components/Packages/PackagesCreateComponent.vue";
import PackagesEditComponent from "./Components/Packages/PackagesEditComponent.vue";
import MenuAndServiceDiscountCrudComponent from "./Components/MenuAndServiceDiscount/MenuAndServiceDiscountCrudComponent.vue";
import RoomDiscountCrudComponent from "./Components/RoomDiscount/RoomDiscountCrudComponent.vue";
import DeliveryChargesCrudComponent from "./Components/DeliveryCharges/DeliveryChargesCrudComponent.vue";
import AccessoriesListComponent from "./Components/Accessories/AccessoriesListComponent.vue";
import AccessoriesCreateComponent from "./Components/Accessories/AccessoriesCreateComponent.vue";
import AccessoriesEditComponent from "./Components/Accessories/AccessoriesEditComponent.vue";
import MrpListComponent from "./Components/MenuPosition/MrpListComponent.vue";
import MrpCreateComponent from "./Components/MenuPosition/MrpCreateComponent.vue";
import MrpEditComponent from "./Components/MenuPosition/MrpEditComponent.vue";
import OkrComponent from "./Components/OKR/OkrComponent.vue";
import OkrCreateComponent from "./Components/OKR/OkrCreateComponent.vue";
import OkrEditComponent from "./Components/OKR/OkrEditComponent.vue";
import KtvProductTreeComponent from "./Components/KtvProductTree/KtvProductTreeComponent.vue";
import KtvProductTreeCreateComponent from "./Components/KtvProductTree/KtvProductTreeCreateComponent.vue";
import KtvProductTreeEditComponent from "./Components/KtvProductTree/KtvProductTreeEditComponent.vue";
import MenuForecastingComponent from "./Components/MenuForecastings/MenuForecastingComponent.vue";
import MenuForecastingCreateComponent from "./Components/MenuForecastings/MenuForecastingCreateComponent.vue";
import MenuForecastingEditComponent from "./Components/MenuForecastings/MenuForecastingEditComponent.vue";
import KtvForecastingComponent from "./Components/KtvForecastings/KtvForecastingComponent.vue";
import KtvForecastingCreateComponent from "./Components/KtvForecastings/KtvForecastingCreateComponent.vue";
import KtvForecastingEditComponent from "./Components/KtvForecastings/KtvForecastingEditComponent.vue";
import CreditorListComponent from "./Components/Creditor/CreditorListComponent.vue";
import CreditorHistoryComponent from "./Components/Creditor/CreditorHistoryComponent.vue";
import OkrDutyComponent from "./Components/OkrDuty/OkrDutyComponent.vue";
import OkrDutyCreateComponent from "./Components/OkrDuty/OkrDutyCreateComponent.vue";
import OkrDutyEditComponent from "./Components/OkrDuty/OkrDutyEditComponent.vue";
import TimeShiftCrudComponent from "./Components/TimeShift/TimeShiftCrudComponent.vue";
import GpsCrudComponent from "./Components/GPS/GpsCrudComponent.vue";
import CheckInComponent from "./Components/CheckIn/CheckInComponent.vue";
import OkrDashboardComponent from "./Components/OkrDashboard/OkrDashboardComponent.vue";
import ContactCrudComponent from "./Components/Contact/ContactCrudComponent.vue";
import LeadTimeComponent from "./Components/LeadTime/LeadTimeComponent.vue";
import ProcurementOrderItemsComponent from "./Components/ProcurementOrderItems/ProcurementOrderItemsComponent.vue";
import ArrivalItemsComponent from "./Components/ArrivalItems/ArrivalItemsComponent.vue";
import PurchaseOrderInvoiceListComponent from "./Components/PurchaseOrderInvoice/PurchaseOrderInvoiceListComponent.vue";
import PurchaseOrderInvoiceDetailComponent from "./Components/PurchaseOrderInvoice/PurchaseOrderInvoiceDetailComponent.vue";
import WorkingCapitalComponent from "./Components/WorkingCapital/WorkingCapitalComponent.vue";
import ProfitAndLossComponent from "./Components/ProfitAndLoss/ProfitAndLossComponent.vue";
import TrialBalanceComponent from "./Components/TrialBalance/TrialBalanceComponent.vue";
import ApBalancesComponent from "./Components/ApBalances/ApBalancesComponent.vue";
import CreditorBalancesComponent from "./Components/CreditorBalances/CreditorBalancesComponent.vue";

import LoginComponent from "./Components/Auth/LoginComponent.vue";
import LogoutComponent from "./Components/Auth/LogoutComponent.vue";

import CustomersListComponent from "./Components/Pos/Customers/CustomersListComponent.vue";
import CustomersCreateComponent from "./Components/Pos/Customers/CustomersCreateComponent.vue";
import HomePageComponent from "./Components/Pos/Home/HomePageComponent.vue";
import HomeComponent from "./Components/Pos/Home/HomeComponent.vue";
import PosArCrudComponent from "./Components/Pos/AR/PosArCrudComponent.vue";
import PosCashbookCrudComponent from "./Components/Pos/Cashbook/PosCashbookCrudComponent.vue";
import CashbookDetailComponent from "./Components/Pos/Cashbook/CashbookDetailComponent.vue";
import InvoiceListComponent from "./Components/Pos/Invoices/InvoiceListComponent.vue";
import InvoiceDetailComponent from "./Components/Pos/Invoices/InvoiceDetailComponent.vue";
import PosBookingListComponent from "./Components/Pos/Booking/PosBookingListComponent.vue";
import PosBookingCreateComponent from "./Components/Pos/Booking/PosBookingCreateComponent.vue";
import PosMenuOrderComponent from "./Components/Pos/MenuOrder/PosMenuOrderComponent.vue";
import PosMenuOrderCreateComponent from "./Components/Pos/MenuOrder/PosMenuOrderCreateComponent.vue";
import UomCrudComponent from "./Components/Uoms/UomCrudComponent.vue";
import PosCustomerDepositComponent from "./Components/Pos/CustomerDeposit/PosCustomerDepositComponent.vue";

import LoginComponentPos from "./Components/Pos/Auth/LoginComponentPos.vue";
import LogoutComponentPos from "./Components/Pos/Auth/LogoutComponentPos.vue";
import PosNotificationComponent from "./Components/Pos/Common/PosNotificationComponent.vue";

import CrmCustomerListComponent from "./Components/CRM/CustomerListComponent.vue";
import CrmCustomerBirthdaysListComponent from "./Components/CRM/CustomerBirthdaysListComponent.vue";
import CrmCustomerDetailComponent from "./Components/CRM/CustomerDetailComponent.vue";
import LevelDiscountCrudComponent from "./Components/CRM/LevelDiscountCrudComponent.vue";
import BirthdayPromotionCrudComponent from "./Components/CRM/BirthdayPromotionCrudComponent.vue";
import CustomTaskCrudComponent from "./Components/Tasks/CustomTaskCrudComponent.vue";
import TasksReportComponent from "./Components/Tasks/TasksReportComponent.vue";
import JournalsCrudComponent from "./Components/Journals/JournalsCrudComponent.vue";
import AdvancedCrudComponent from "./Components/Advanced/AdvancedCrudComponent.vue";
import AdvancedDetailComponent from "./Components/Advanced/AdvancedDetailComponent.vue";
import AdvancesCrudComponent from "./Components/Advances/AdvancesCrudComponent.vue";
import AdvancesDetailComponent from "./Components/Advances/AdvancesDetailComponent.vue";
import PrepaidCrudComponent from "./Components/Prepaid/PrepaidCrudComponent.vue";
import CashFlowStatementComponent from "./Components/CashFlowStatement/CashFlowStatementComponent.vue";
import IndirectCashFlowStatementComponent from "./Components/CashFlowStatement/IndirectCashFlowStatementComponent.vue";
import SkillCrudComponent from "./Components/Skill/SkillCrudComponent.vue";
import CookingPlaceComponent from "./Components/CookingPlace/CookingPlaceComponent.vue";
import CookingPlaceCreateComponent from "./Components/CookingPlace/CookingPlaceCreateComponent.vue";
import CookingPlaceEditComponent from "./Components/CookingPlace/CookingPlaceEditComponent.vue";
import AssetItemList from "./Components/FixedAssets/AssetItemList.vue";
import AssetListCompoennt from "./Components/FixedAssets/AssetListComponent.vue";
import DutyComponent from "./Components/Duty/DutyComponent.vue";
import DutyCreateComponent from "./Components/Duty/DutyCreateComponent.vue";
import DutyEditComponent from "./Components/Duty/DutyEditComponent.vue";
import AssetDepreciationBalanceList from "./Components/AssetDepreciationBalance/AssetDepreciationBalanceList.vue";
import FixedAssetDepreciationList from "./Components/AssetDepreciationBalance/FixedAssetDepreciationList.vue";
import ItemUsageForecastListMonth from "./Components/ItemUsageForecastings/ItemUsageForecastListMonth.vue";
import ItemUsageForecastByMonthWithDepartment from "./Components/ItemUsageForecastings/ItemUsageForecastByMonthWithDepartment.vue";
import IufWithDepartmentAndMonth from "./Components/ItemUsageForecastings/IufWithDepartmentAndMonth.vue";
import SaleTargetPositionListComponent from "./Components/SaleTarget/SaleTargetPositionListComponent.vue";
import SaleTargetPositionCreateComponent from "./Components/SaleTarget/SaleTargetPositionCreateComponent.vue";
import SaleTargetPositionEditComponent from "./Components/SaleTarget/SaleTargetPositionEditComponent.vue";
import SaleTargetMenuListComponent from "./Components/SaleTarget/SaleTargetMenuListComponent.vue";
import SaleTargetMenuCreateComponent from "./Components/SaleTarget/SaleTargetMenuCreateComponent.vue";
import SaleTargetMenuEditComponent from "./Components/SaleTarget/SaleTargetMenuEditComponent.vue";
import MenuSaleReportComponent from "./Components/Menus/MenuSaleReportComponent.vue";
import MenuCostingComponent from "./Components/Menus/MenuCostingComponent.vue";
import PosOrderItemList from "./Components/Pos/OrderItem/PosOrderItemList.vue";
import MeetingListComponent from "./Components/Meeting/MeetingListComponent.vue";
import MeetingCreateComponent from "./Components/Meeting/MeetingCreateComponent.vue";
import MeetingEditComponent from "./Components/Meeting/MeetingEditComponent.vue";
import TrainingListComponent from "./Components/Training/TrainingListComponent.vue";
import TrainingCreateComponent from "./Components/Training/TrainingCreateComponent.vue";
import TrainingEditComponent from "./Components/Training/TrainingEditComponent.vue";
import OrgNewsListComponent from "./Components/OrgNews/OrgNewsListComponent.vue";
import OrgNewsCreateComponent from "./Components/OrgNews/OrgNewsCreateComponent.vue";
import OrgNewsEditComponent from "./Components/OrgNews/OrgNewsEditComponent.vue";
import WarningListComponent from "./Components/Warning/WarningListComponent.vue";
import WarningCreateComponent from "./Components/Warning/WarningCreateComponent.vue";
import WarningEditComponent from "./Components/Warning/WarningEditComponent.vue";
import MenuAreaComponent from "./Components/MenuArea/MenuAreaComponent.vue";
import OffDayCrudComponent from "./Components/OffDay/OffDayCrudComponent.vue";
import OffDaySettingComponent from "./Components/OffDaySetting/OffDaySettingComponent.vue";
import OffDayRequestListComponent from "./Components/OffDayRequest/OffDayRequestListComponent.vue";
import HolidayCrudComponent from "./Components/Holiday/HolidayCrudComponent.vue";
import LeaveAllowanceComponent from "./Components/LeaveAllowance/LeaveAllowanceComponent.vue";
import LeaveAllowanceCreateComponent from "./Components/LeaveAllowance/LeaveAllowanceCreateComponent.vue";
import LeaveComponent from "./Components/Leave/LeaveComponent.vue";
import ExitPassComponent from "./Components/ExitPass/ExitPassComponent.vue";
import OvertimeFeesCrudComponent from "./Components/OvertimeFees/OvertimeFeesCrudComponent.vue";
import OvertimeConfirmationCrudComponent from "./Components/OvertimeConfirmation/OvertimeConfirmationCrudComponent.vue";
import SalarySetupListComponent from "./Components/SalarySetup/SalarySetupListComponent.vue";
import SalarySetupCreateComponent from "./Components/SalarySetup/SalarySetupCreateComponent.vue";
import SalarySetupEditComponent from "./Components/SalarySetup/SalarySetupEditComponent.vue";
import SalaryCrudComponent from "./Components/Salary/SalaryCrudComponent.vue";
import AllowanceCrudComponent from "./Components/Allowance/AllowanceCrudComponent.vue";
import SalaryBatchListComponent from "./Components/SalaryBatch/SalaryBatchListComponent.vue";
import SalaryBatchCreateComponent from "./Components/SalaryBatch/SalaryBatchCreateComponent.vue";
import SalaryBatchEditComponent from "./Components/SalaryBatch/SalaryBatchEditComponent.vue";
import SalaryCalculateComponent from "./Components/SalaryCalculate/SalaryCalculateComponent.vue";
import PaySlipComponent from "./Components/SalaryCalculate/PaySlipComponent.vue";
import ResignationCategoriesCrudComponent from "./Components/ResignationCategories/ResignationCategoriesCrudComponent.vue";
import ResignationCrudComponent from "./Components/Resignations/ResignationCrudComponent.vue";
import EventCrudComponent from "./Components/Events/EventCrudComponent.vue";

import PosSellingAreasComponent from "./Components/Pos/Areas/PosSellingAreasComponent.vue";
import PosTableComponent from "./Components/Pos/Home/PosTableComponent.vue";
import PosRoomComponent from "./Components/Pos/Home/PosRoomComponent.vue";
import PosSaleReportComponent from "./Components/Pos/SaleReports/PosSaleReportComponent.vue";
import PosSaleInvoiceReportComponent from "./Components/Pos/SaleInvoiceReport/PosSaleInvoiceReportComponent.vue";
import PosOrderComponent from "./Components/Pos/Home/PosOrderComponent.vue";

import CvFormComponent from "./Components/CV/CvFormComponent.vue";
import CvListComponent from "./Components/CV/CvListComponent.vue";
import CvDetailComponent from "./Components/CV/CvDetailComponent.vue";
import OpenCommunicationFormComponent from "./Components/CV/OpenCommunicationFormComponent.vue";
import ExamListComponent from "./Components/Exams/ExamListComponent.vue";
import ExamCreateComponent from "./Components/Exams/ExamCreateComponent.vue";
import ExamEditComponent from "./Components/Exams/ExamEditComponent.vue";
import ExamAssessmentComponent from "./Components/Exams/ExamAssessmentComponent.vue";
import InterviewListComponent from "./Components/Interviews/InterviewListComponent.vue";
import InterviewCreateComponent from "./Components/Interviews/InterviewCreateComponent.vue";
import InterviewResultComponent from "./Components/Interviews/InterviewResultComponent.vue";
import LocationListComponent from "./Components/Locations/LocationListComponent.vue";
import LocationDetailComponent from "./Components/Locations/LocationDetailComponent.vue";
import JdCrudComponent from "./Components/JobDescription/JdCrudComponent.vue";
import JsListComponent from "./Components/JobSpecification/JsListComponent.vue";
import JsCreateComponent from "./Components/JobSpecification/JsCreateComponent.vue";
import JsEditComponent from "./Components/JobSpecification/JsEditComponent.vue";
import SopListComponent from "./Components/SOP/SopListComponent.vue";
import SopCreateComponent from "./Components/SOP/SopCreateComponent.vue";
import OkrAssignComponent from "./Components/OkrAssign/OkrAssignComponent.vue";
import OkrAssignCreateComponent from "./Components/OkrAssign/OkrAssignCreateComponent.vue";
import OkrAssignEditComponent from "./Components/OkrAssign/OkrAssignEditComponent.vue";
import OkrAssignDetailComponent from "./Components/OkrAssign/OkrAssignDetailComponent.vue";
import HandbooksListComponent from "./Components/Handbooks/HandbooksListComponent.vue";
import HandbooksCreateComponent from "./Components/Handbooks/HandbooksCreateComponent.vue";
import ShiftAssignmentListComponent from "./Components/ShiftAssignment/ShiftAssignmentListComponent.vue";
import ShiftAssignmentCreateComponent from "./Components/ShiftAssignment/ShiftAssignmentCreateComponent.vue";
import AssetAssignmentCrudComponent from "./Components/AssetAssignment/AssetAssignmentCrudComponent.vue";
import EquipmentAssignmentListComponent from "./Components/EquipmentAssignment/EquipmentAssignmentListComponent.vue";
import EquipmentAssignmentCreateComponent from "./Components/EquipmentAssignment/EquipmentAssignmentCreateComponent.vue";
import ShiftCrudComponent from "./Components/Shift/ShiftCrudComponent.vue";
import PosCashbookHistoryComponent from "./Components/Pos/Cashbook/PosCashbookHistoryComponent.vue";
import CashbookHistoryComponent from "./Components/Cashbook/CashbookHistoryComponent.vue";
import AccrualsCrudComponent from "./Components/Accruals/AccrualsCrudComponent.vue";
import AccrualsListComponent from "./Components/Accruals/AccrualsListComponent.vue";
import LoansListComponent from "./Components/Loans/LoansListComponent.vue";
import LoanDetailsComponent from "./Components/Loans/LoanDetailsComponent.vue";
import SaleLedgerComponent from "./Components/SaleLedgers/SaleLedgerComponent.vue";
import SaleLedgerKtvComponent from "./Components/SaleLedgers/SaleLedgerKtvComponent.vue";
import SaleLedgerRestaurantComponent from "./Components/SaleLedgers/SaleLedgerRestaurantComponent.vue";
import SideBarComponent from "./Components/Common/SideBarComponent.vue";
// import KtvReportComponent from './Components/KtvReport/KtvReportComponent.vue';
import DailyAreaSalesByStaffReport from "./Components/CateringReport/DailyAreaSalesByStaffReport.vue";
import TargetActualMenuSalesReport from "./Components/CateringReport/TargetActualMenuSalesReport.vue";
import KtvReportChartComponent from "./Components/KtvReport/KtvReportChartComponent.vue";
import BarReportChartComponent from "./Components/BarReport/BarReportChartComponent.vue";
import KitchenReportChartComponent from "./Components/KitchenReport/KitchenReportChartComponent.vue";
import KtvMenuSaleComponent from "./Components/KitchenMenuSale/KtvMenuSaleComponent.vue";
import SkyMenuSaleComponent from "./Components/KitchenMenuSale/SkyMenuSaleComponent.vue";
import BudgetAccountCrudComponent from "./Components/BudgetAccounts/BudgetAccountCrudComponent.vue";
import CashflowReportComponent from "./Components/CashflowReport/CashflowReportComponent.vue";
import BenefitsCrudComponent from "./Components/Benefits/BenefitsCrudComponent.vue";
import BenefitsRequestComponent from "./Components/Benefits/BenefitsRequestComponent.vue";
import ContractComponent from "./Components/Contract/ContractComponent.vue";
import ContractCreateComponent from "./Components/Contract/ContractCreateComponent.vue";
import SignedContractsListComponent from "./Components/Contract/SignedContractsListComponent.vue";
import MeetingOperationComponent from "./Components/Meeting/MeetingOperationComponent.vue";
import ProjectListComponent from "./Components/Project/ProjectListComponent.vue";
import ProjectInstructionComponent from "./Components/Project/ProjectInstructionComponent.vue";
import PosSessionReportComponent from "./Components/Pos/SessionReport/PosSessionReportComponent.vue";

app.component("NavBarComponent", NavBarComponent);
app.component("StaffListComponent", StaffListComponent);
app.component("StaffCreateComponent", StaffCreateComponent);
app.component("StaffEditComponent", StaffEditComponent);
app.component("TasksCrudComponent", TasksCrudComponent);
app.component("TaskReportComponent", TaskReportComponent);
app.component("DepartmentsCrudComponent", DepartmentsCrudComponent);
app.component("RolesCrudComponent", RolesCrudComponent);
app.component("AreasCrudComponent", AreasCrudComponent);
app.component("InventoriesCrudComponent", InventoriesCrudComponent);
app.component("RoomCrudComponent", RoomCrudComponent);
app.component("ServicesCrudComponent", ServicesCrudComponent);
app.component("InventoryLedgersComponent", InventoryLedgersComponent);
app.component("InventoryOpeningComponent", InventoryOpeningComponent);
app.component("InventoryReceivesListComponent", InventoryReceivesListComponent);
app.component(
    "InventoryTransfersListComponent",
    InventoryTransfersListComponent,
);
app.component(
    "InventoryTransferHistoryListComponent",
    InventoryTransferHistoryListComponent,
);
app.component("UsedDefectedItemsListComponent", UsedDefectedItemsListComponent);
app.component("MenuCategoryCrudComponent", MenuCategoryCrudComponent);
app.component("MenuListComponent", MenuListComponent);
app.component("MenuCreateComponent", MenuCreateComponent);
app.component("MenuEditComponent", MenuEditComponent);
app.component("ComplainsCrudComponent", ComplainsCrudComponent);
app.component("AccountingCrudComponent", AccountingCrudComponent);
app.component(
    "FinancialTransactionCrudComponent",
    FinancialTransactionCrudComponent,
);
app.component("CashbookCrudComponent", CashbookCrudComponent);
app.component("ApListComponent", ApListComponent);
app.component("ApHistoryComponent", ApHistoryComponent);
app.component("ArCrudComponent", ArCrudComponent);
app.component("ArDetailComponent", ArDetailComponent);
app.component("ArHistoryComponent", ArHistoryComponent);
app.component("ArPaidComponent", ArPaidComponent);
app.component("PackagesListComponent", PackagesListComponent);
app.component("PackagesCreateComponent", PackagesCreateComponent);
app.component("PackagesEditComponent", PackagesEditComponent);
app.component(
    "MenuAndServiceDiscountCrudComponent",
    MenuAndServiceDiscountCrudComponent,
);
app.component("RoomDiscountCrudComponent", RoomDiscountCrudComponent);
app.component("DeliveryChargesCrudComponent", DeliveryChargesCrudComponent);
app.component("AccessoriesListComponent", AccessoriesListComponent);
app.component("AccessoriesCreateComponent", AccessoriesCreateComponent);
app.component("AccessoriesEditComponent", AccessoriesEditComponent);
app.component("MrpListComponent", MrpListComponent);
app.component("MrpCreateComponent", MrpCreateComponent);
app.component("MrpEditComponent", MrpEditComponent);
app.component("OkrComponent", OkrComponent);
app.component("OkrCreateComponent", OkrCreateComponent);
app.component("OkrEditComponent", OkrEditComponent);
app.component("KtvProductTreeComponent", KtvProductTreeComponent);
app.component("KtvProductTreeCreateComponent", KtvProductTreeCreateComponent);
app.component("KtvProductTreeEditComponent", KtvProductTreeEditComponent);
app.component("MenuForecastingComponent", MenuForecastingComponent);
app.component("MenuForecastingCreateComponent", MenuForecastingCreateComponent);
app.component("MenuForecastingEditComponent", MenuForecastingEditComponent);
app.component("KtvForecastingComponent", KtvForecastingComponent);
app.component("KtvForecastingCreateComponent", KtvForecastingCreateComponent);
app.component("KtvForecastingEditComponent", KtvForecastingEditComponent);
app.component("CreditorListComponent", CreditorListComponent);
app.component("CreditorHistoryComponent", CreditorHistoryComponent);
app.component("OkrDutyComponent", OkrDutyComponent);
app.component("OkrDutyCreateComponent", OkrDutyCreateComponent);
app.component("OkrDutyEditComponent", OkrDutyEditComponent);
app.component("TimeShiftCrudComponent", TimeShiftCrudComponent);
app.component("GpsCrudComponent", GpsCrudComponent);
app.component("CheckInComponent", CheckInComponent);
app.component("OkrDashboardComponent", OkrDashboardComponent);
app.component("ContactCrudComponent", ContactCrudComponent);
app.component("LeadTimeComponent", LeadTimeComponent);
app.component("ProcurementOrderItemsComponent", ProcurementOrderItemsComponent);
app.component("ArrivalItemsComponent", ArrivalItemsComponent);
app.component(
    "PurchaseOrderInvoiceListComponent",
    PurchaseOrderInvoiceListComponent,
);
app.component(
    "PurchaseOrderInvoiceDetailComponent",
    PurchaseOrderInvoiceDetailComponent,
);
app.component("WorkingCapitalComponent", WorkingCapitalComponent);
app.component("ProfitAndLossComponent", ProfitAndLossComponent);
app.component("TrialBalanceComponent", TrialBalanceComponent);
app.component("ApBalancesComponent", ApBalancesComponent);
app.component("CreditorBalancesComponent", CreditorBalancesComponent);

app.component("PurchaseOrderListComponent", PurchaseOrderListComponent);
app.component("PurchaseOrderCreateComponent", PurchaseOrderCreateComponent);
app.component("PurchaseOrderEditComponent", PurchaseOrderEditComponent);
app.component("PurchaseOrderConfirmComponent", PurchaseOrderConfirmComponent);
app.component("PurchaseOrderBuyComponent", PurchaseOrderBuyComponent);
app.component(
    "ConfirmPurchaseOrderItemsComponent",
    ConfirmPurchaseOrderItemsComponent,
);
app.component(
    "PurchaseOrderWithLeftItemsComponent",
    PurchaseOrderWithLeftItemsComponent,
);
app.component("LeftItemListComponent", LeftItemListComponent);
app.component("BrandCrudComponent", BrandCrudComponent);
app.component("ItemListComponent", ItemListComponent);
app.component("ItemCreateComponent", ItemCreateComponent);
app.component("ItemEditComponent", ItemEditComponent);
app.component("SellingExtraListComponent", SellingExtraListComponent);
app.component("ItemPricingHistoryComponent", ItemPricingHistoryComponent);
app.component("ItemSuppliersComponent", ItemSuppliersComponent);
app.component("SupplierBrandsComponent", SupplierBrandsComponent);
app.component("ItemUsageForecastListComponent", ItemUsageForecastListComponent);
app.component(
    "ItemUsageForecastCreateComponent",
    ItemUsageForecastCreateComponent,
);
app.component(
    "ItemUsageForecastDetailComponent",
    ItemUsageForecastDetailComponent,
);
app.component("UomConversionCrudComponent", UomConversionCrudComponent);
app.component("UomCrudComponent", UomCrudComponent);
app.component("TableCrudComponent", TableCrudComponent);

app.component("SupplierListComponent", SupplierListComponent);
app.component("SupplierCreateComponent", SupplierCreateComponent);
app.component("SupplierUpdateComponent", SupplierUpdateComponent);
app.component("SupplierDetailComponent", SupplierDetailComponent);
app.component("SupplierLeadTimeComponent", SupplierLeadTimeComponent);

app.component("FixedAssetCrudComponent", FixedAssetCrudComponent);
app.component("AssetItemCrudComponent", AssetItemCrudComponent);
app.component("AssetCrudComponent", AssetCrudComponent);

app.component("LoginComponent", LoginComponent);
app.component("LogoutComponent", LogoutComponent);
app.component("PosNotificationComponent", PosNotificationComponent);

app.component("CustomersListComponent", CustomersListComponent);
app.component("CustomersCreateComponent", CustomersCreateComponent);
app.component("HomePageComponent", HomePageComponent);
app.component("HomeComponent", HomeComponent);
app.component("PosArCrudComponent", PosArCrudComponent);
app.component("PosCashbookCrudComponent", PosCashbookCrudComponent);
app.component("CashbookDetailComponent", CashbookDetailComponent);
app.component("InvoiceListComponent", InvoiceListComponent);
app.component("InvoiceDetailComponent", InvoiceDetailComponent);
app.component("PosBookingListComponent", PosBookingListComponent);
app.component("PosBookingCreateComponent", PosBookingCreateComponent);
app.component("PosMenuOrderComponent", PosMenuOrderComponent);
app.component("PosMenuOrderCreateComponent", PosMenuOrderCreateComponent);
app.component("PosCustomerDepositComponent", PosCustomerDepositComponent);

app.component("LoginComponentPos", LoginComponentPos);
app.component("LogoutComponentPos", LogoutComponentPos);

app.component("CrmCustomerListComponent", CrmCustomerListComponent);
app.component(
    "CrmCustomerBirthdaysListComponent",
    CrmCustomerBirthdaysListComponent,
);
app.component("LevelDiscountCrudComponent", LevelDiscountCrudComponent);
app.component("BirthdayPromotionCrudComponent", BirthdayPromotionCrudComponent);
app.component("CrmCustomerDetailComponent", CrmCustomerDetailComponent);
app.component("CustomTaskCrudComponent", CustomTaskCrudComponent);
app.component("TasksReportComponent", TasksReportComponent);
app.component("JournalsCrudComponent", JournalsCrudComponent);
app.component("AdvancedCrudComponent", AdvancedCrudComponent);
app.component("AdvancedDetailComponent", AdvancedDetailComponent);
app.component("AdvancesCrudComponent", AdvancesCrudComponent);
app.component("AdvancesDetailComponent", AdvancesDetailComponent);
app.component("PrepaidCrudComponent", PrepaidCrudComponent);
app.component("CashFlowStatementComponent", CashFlowStatementComponent);
app.component(
    "IndirectCashFlowStatementComponent",
    IndirectCashFlowStatementComponent,
);
app.component("SkillCrudComponent", SkillCrudComponent);
app.component("CookingPlaceComponent", CookingPlaceComponent);
app.component("CookingPlaceCreateComponent", CookingPlaceCreateComponent);
app.component("CookingPlaceEditComponent", CookingPlaceEditComponent);
app.component("AssetItemList", AssetItemList);
app.component("AssetListComponent", AssetListCompoennt);
app.component("DutyComponent", DutyComponent);
app.component("DutyCreateComponent", DutyCreateComponent);
app.component("DutyEditComponent", DutyEditComponent);
app.component("ItemUsageForecastListMonth", ItemUsageForecastListMonth);
app.component(
    "ItemUsageForecastByMonthWithDepartment",
    ItemUsageForecastByMonthWithDepartment,
);
app.component("IufWithDepartmentAndMonth", IufWithDepartmentAndMonth);
app.component("AssetDepreciationBalanceList", AssetDepreciationBalanceList);
app.component("FixedAssetDepreciationList", FixedAssetDepreciationList);
app.component(
    "SaleTargetPositionListComponent",
    SaleTargetPositionListComponent,
);
app.component(
    "SaleTargetPositionCreateComponent",
    SaleTargetPositionCreateComponent,
);
app.component(
    "SaleTargetPositionEditComponent",
    SaleTargetPositionEditComponent,
);
app.component("SaleTargetMenuListComponent", SaleTargetMenuListComponent);
app.component("SaleTargetMenuCreateComponent", SaleTargetMenuCreateComponent);
app.component("SaleTargetMenuEditComponent", SaleTargetMenuEditComponent);
app.component("MenuSaleReportComponent", MenuSaleReportComponent);
app.component("MenuCostingComponent", MenuCostingComponent);
app.component("PosOrderItemList", PosOrderItemList);
app.component("MeetingListComponent", MeetingListComponent);
app.component("MeetingCreateComponent", MeetingCreateComponent);
app.component("MeetingEditComponent", MeetingEditComponent);
app.component("TrainingListComponent", TrainingListComponent);
app.component("TrainingCreateComponent", TrainingCreateComponent);
app.component("TrainingEditComponent", TrainingEditComponent);
app.component("OrgNewsListComponent", OrgNewsListComponent);
app.component("OrgNewsCreateComponent", OrgNewsCreateComponent);
app.component("OrgNewsEditComponent", OrgNewsEditComponent);
app.component("WarningListComponent", WarningListComponent);
app.component("WarningCreateComponent", WarningCreateComponent);
app.component("WarningEditComponent", WarningEditComponent);
app.component("MenuAreaComponent", MenuAreaComponent);
app.component("OffDayCrudComponent", OffDayCrudComponent);
app.component("OffDaySettingComponent", OffDaySettingComponent);
app.component("OffDayRequestListComponent", OffDayRequestListComponent);
app.component("HolidayCrudComponent", HolidayCrudComponent);
app.component("LeaveAllowanceComponent", LeaveAllowanceComponent);
app.component("LeaveAllowanceCreateComponent", LeaveAllowanceCreateComponent);
app.component("LeaveComponent", LeaveComponent);
app.component("ExitPassComponent", ExitPassComponent);
app.component("OvertimeFeesCrudComponent", OvertimeFeesCrudComponent);
app.component(
    "OvertimeConfirmationCrudComponent",
    OvertimeConfirmationCrudComponent,
);
app.component("SalarySetupListComponent", SalarySetupListComponent);
app.component("SalarySetupCreateComponent", SalarySetupCreateComponent);
app.component("SalarySetupEditComponent", SalarySetupEditComponent);
app.component("SalaryCrudComponent", SalaryCrudComponent);
app.component("AllowanceCrudComponent", AllowanceCrudComponent);
app.component("SalaryBatchListComponent", SalaryBatchListComponent);
app.component("SalaryBatchCreateComponent", SalaryBatchCreateComponent);
app.component("SalaryBatchEditComponent", SalaryBatchEditComponent);
app.component("SalaryCalculateComponent", SalaryCalculateComponent);
app.component("PaySlipComponent", PaySlipComponent);
app.component(
    "ResignationCategoriesCrudComponent",
    ResignationCategoriesCrudComponent,
);
app.component("ResignationCrudComponent", ResignationCrudComponent);
app.component("EventCrudComponent", EventCrudComponent);

app.component("PosSellingAreasComponent", PosSellingAreasComponent);
app.component("PosTableComponent", PosTableComponent);
app.component("PosRoomComponent", PosRoomComponent);
app.component("PosSaleReportComponent", PosSaleReportComponent);
app.component("PosSaleInvoiceReportComponent", PosSaleInvoiceReportComponent);
app.component("PosSessionReportComponent", PosSessionReportComponent);
app.component("PosOrderComponent", PosOrderComponent);

app.component("CvFormComponent", CvFormComponent);
app.component("CvListComponent", CvListComponent);
app.component("CvDetailComponent", CvDetailComponent);
app.component("OpenCommunicationFormComponent", OpenCommunicationFormComponent);
app.component("ExamListComponent", ExamListComponent);
app.component("ExamCreateComponent", ExamCreateComponent);
app.component("ExamEditComponent", ExamEditComponent);
app.component("ExamAssessmentComponent", ExamAssessmentComponent);
app.component("InterviewListComponent", InterviewListComponent);
app.component("InterviewCreateComponent", InterviewCreateComponent);
app.component("InterviewResultComponent", InterviewResultComponent);
app.component("LocationListComponent", LocationListComponent);
app.component("LocationDetailComponent", LocationDetailComponent);
app.component("JdCrudComponent", JdCrudComponent);
app.component("JsListComponent", JsListComponent);
app.component("JsCreateComponent", JsCreateComponent);
app.component("JsEditComponent", JsEditComponent);
app.component("SopListComponent", SopListComponent);
app.component("SopCreateComponent", SopCreateComponent);
app.component("OkrAssignComponent", OkrAssignComponent);
app.component("OkrAssignCreateComponent", OkrAssignCreateComponent);
app.component("OkrAssignEditComponent", OkrAssignEditComponent);
app.component("OkrAssignDetailComponent", OkrAssignDetailComponent);
app.component("HandbooksListComponent", HandbooksListComponent);
app.component("HandbooksCreateComponent", HandbooksCreateComponent);
app.component("ShiftAssignmentListComponent", ShiftAssignmentListComponent);
app.component("ShiftAssignmentCreateComponent", ShiftAssignmentCreateComponent);
app.component("AssetAssignmentCrudComponent", AssetAssignmentCrudComponent);
app.component(
    "EquipmentAssignmentListComponent",
    EquipmentAssignmentListComponent,
);
app.component(
    "EquipmentAssignmentCreateComponent",
    EquipmentAssignmentCreateComponent,
);
app.component("ShiftCrudComponent", ShiftCrudComponent);
app.component("PosCashbookHistoryComponent", PosCashbookHistoryComponent);
app.component("CashbookHistoryComponent", CashbookHistoryComponent);
app.component("AccrualsCrudComponent", AccrualsCrudComponent);
app.component("AccrualsListComponent", AccrualsListComponent);
app.component("LoansListComponent", LoansListComponent);
app.component("LoanDetailsComponent", LoanDetailsComponent);
app.component("SaleLedgerComponent", SaleLedgerComponent);
app.component("SaleLedgerKtvComponent", SaleLedgerKtvComponent);
app.component("SaleLedgerRestaurantComponent", SaleLedgerRestaurantComponent);
app.component("SideBarComponent", SideBarComponent);
// app.component('KtvReportComponent',KtvReportComponent);
app.component("DailyAreaSalesByStaffReport", DailyAreaSalesByStaffReport);
app.component("TargetActualMenuSalesReport", TargetActualMenuSalesReport);
app.component("KtvReportChartComponent", KtvReportChartComponent);
app.component("BarReportChartComponent", BarReportChartComponent);
app.component("KitchenReportChartComponent", KitchenReportChartComponent);
app.component("KtvMenuSaleComponent", KtvMenuSaleComponent);
app.component("SkyMenuSaleComponent", SkyMenuSaleComponent);
app.component("BudgetAccountCrudComponent", BudgetAccountCrudComponent);
app.component("CashflowReportComponent", CashflowReportComponent);
app.component("BenefitsCrudComponent", BenefitsCrudComponent);
app.component("BenefitsRequestComponent", BenefitsRequestComponent);
app.component("ContractComponent", ContractComponent);
app.component("ContractCreateComponent", ContractCreateComponent);
app.component("SignedContractsListComponent", SignedContractsListComponent);
app.component("MeetingOperationComponent", MeetingOperationComponent);
app.component("ProjectListComponent", ProjectListComponent);
app.component("ProjectInstructionComponent", ProjectInstructionComponent);

const toastificationOptions = {};
app.use(store);
app.use(Notifications);
app.use(Toast, toastificationOptions);
app.mount("#app");
